export default __webpack_public_path__ + "static/media/Mukti.71198d01.ttf";